<template>
  <div class="guest-params">
    <el-row>
      <el-col :span="12">
        預約單編號規則:
        <el-input
          v-model="childrenData.BookingNumberPrefix"
          style="width: 200px"
          size="small"
        ></el-input>
        <el-select
          v-model="childrenData.BookingNumberLength"
          style="width: 60px"
          placeholder=" "
          size="small"
        >
          <el-option
            v-for="item in ['5', '6', '7', '8', '9']"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="12">
        預約單編號初始值:
        <el-input-number
          v-model="childrenData.BookingNumberInitialization"
          controls-position="right"
          size="small"
        ></el-input-number>
      </el-col>
      <el-col :span="12">
        Invoice Number初始值:
        <el-input-number
          v-model="childrenData.InvoiceNumberInitialization"
          controls-position="right"
          size="small"
        ></el-input-number>
      </el-col>
    </el-row>
    <span class="btn">
      <el-button size="small" type="warning" @click="reset">{{
        $t("app.reset")
      }}</el-button>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    childrenData: {
      type: Object,
      default() {
        return {
          BookingNumberPrefix: "EAHR",
          BookingNumberLength: "6",
          BookingNumberInitialization: 1,
          InvoiceNumberInitialization: 10000,
        };
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    reset() {
      this.childrenData.BookingNumberPrefix = "EAHR";
      this.childrenData.BookingNumberLength = "6";
      this.childrenData.BookingNumberInitialization = 1;
      this.childrenData.InvoiceNumberInitialization = 10000;
    },
  },
};
</script>
<style lang="scss" scoped>
.guest-params {
  min-height: 150px;
  padding-bottom: 50px;
  .el-row {
    .el-col {
      margin-bottom: 15px;
    }
  }
  .btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
</style>
